import {
  OFFER_LIST_GET,
} from "../../fetch/url";
import { get } from '../../fetch/fetch';
import { actionTypes } from "./constants";
  
export const setOfferList = data => ({
  type: actionTypes.SET_OFFER_LIST,
  data
});

export const setMessage = data => ({
  type: actionTypes.SET_MESSAGE,
  data
});

export const getOfferList = (params) => {
  return dispatch => {
    get(OFFER_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setOfferList({
            list: data.rows,
            total: data.total,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取报价单列表失败！',
        }));
      });
  };
};